export const clientID = "GAqKAHmfP27RlJ0tnxgaRdi3Z3mdtX01OCzjy5ad";
export const clientSecret =
  "RwtlTIII552UeVTD62ynTUbIK98INGqkUyoQecce5xD0E4FnBnAIlCfaEnLYd8QemGm2CS14xmMkHamI4MtFaQsyOapswVpy1hHIhB35IKaA9D5V5Vy2FDpT9sQi9liN";

export const googleClientID = "VEdtiN14AUo2ymboht5DNVzvs8Pd3V8QTn4dLI8i";
export const googleClientSecret =
  "3TCNBR7lmOK7zLZdw7lq4EzoS9YcOOXHODpsy7Bt1OAD0FzhtRyIoveCYkSxRUTW9kLci3IgHRp0flgZbgmS0jOOocT0M65gofHwOVB2kTZjPBDAYeXNt0cxsyGoBXHQ";

export const facebookClientID = "ubQ4qgmIbuFGD14S3XwatbAFM5wANYJsE9Gt3Xsy";
export const facebookClientSecret =
  "8h1CpruoTSZmYHTwbGRMDhlFAdjYTQhM7fGnj4Hxf1bUWrUI9HLuhFSZDPSGUT34V9ccN8nQKpkj4AOHLuk8IuwM9Sf5cqLyVPdZfssIj4Pn4LSW5RfxcAT0Xiu5Dbot";
